import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Catalog } from "@modules/catalogs/types";
import { CatalogFormValues } from "@modules/catalogs/validations";
import { editCatalogService } from "./service";
import { UseEditCatalogMutationOptions } from "./types";

export function useEditCatalogMutation(
  options?: UseEditCatalogMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Catalog, ApiError, { id: string; data: CatalogFormValues }>({
    mutationFn: ({ id, data }) => editCatalogService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("agreement_catalogs.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
